import React, { Component } from 'react';

class IconReportSendEmail extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="37"
                fill="none"
                viewBox="0 0 36 37"
            >
                <path
                    fill="#26A"
                    d="M16.26 18.381c-.142-.126-.284-.22-.41-.33-2.867-2.852-5.75-5.704-8.634-8.556-.473-.457-.599-.945-.362-1.465.252-.567.709-.772 1.307-.772H32.63c.866 0 1.37.504 1.37 1.37v19.743c0 .866-.52 1.37-1.386 1.37H8.145c-.598 0-1.055-.204-1.307-.772-.237-.567-.048-1.04.362-1.465 2.93-2.946 5.846-5.908 8.776-8.855.095-.063.158-.142.284-.268zm4.128.63c3.12-3.087 6.207-6.144 9.311-9.232H11.076c3.12 3.104 6.192 6.16 9.312 9.233zm-9.375 8.225h18.718c-2.348-2.379-4.664-4.71-7.011-7.09l-1.292 1.34c-.725.724-1.371.724-2.096 0-.441-.442-.867-.883-1.308-1.34-2.363 2.395-4.663 4.711-7.011 7.09zm13.613-8.729c2.237 2.253 4.538 4.585 6.854 6.933V11.48c-2.316 2.38-4.57 4.696-6.854 7.027z"
                ></path>
                <path
                    fill="#26A"
                    d="M6.394 15.01H4.867a1.278 1.278 0 01-1.292-1.245c0-.693.567-1.26 1.276-1.26h3.12c.725 0 1.276.551 1.276 1.26 0 .71-.551 1.23-1.292 1.245h-1.56zM6.41 24.51H4.85c-.708 0-1.291-.567-1.275-1.26 0-.678.567-1.23 1.26-1.245h3.151c.71 0 1.26.551 1.26 1.245 0 .709-.55 1.244-1.276 1.26H6.41zM4.82 19.752H3.26c-.724 0-1.26-.551-1.26-1.26 0-.694.551-1.23 1.26-1.23h3.152c.693 0 1.26.568 1.26 1.245 0 .678-.567 1.245-1.26 1.245-.52.016-1.056 0-1.592 0z"
                ></path>
            </svg>
        );
    }
}

export default IconReportSendEmail;